import { Section } from '../components/ui/Section'
import { ContactForm } from '../components/forms/ContactForm'

export function ContactPage() {
  return (
    <>
      {/* Hero */}
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 md:py-24">
        <div className="container-narrow">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 text-balance">
            Get in Touch
          </h1>
          <p className="mt-6 text-xl text-slate-600 leading-relaxed">
            Have questions about N = 1 theory, our projects, or potential collaboration? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Form */}
      <Section narrow className="bg-white pt-0">
        <div className="bg-slate-50 rounded-xl p-6 md:p-10">
          <ContactForm />
        </div>

        {/* Additional Info */}
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">For Healthcare Inquiries</h3>
            <p className="text-slate-600 text-sm">
              Interested in clinical documentation tools, EHR workflow optimization, or healthcare AI? Select "Healthcare Applications" in the form above.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">For AI & Research</h3>
            <p className="text-slate-600 text-sm">
              Questions about N = 1 theory, AI alignment applications, or potential research collaboration? Select "AI & Alignment" or "Theory of N=1" above.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">Retired SEC Tools</h3>
            <p className="text-slate-600 text-sm">
              8K Getter, Form4Getter, and FilingsGetter are retired. For closure, data, or domain inquiries, select "Retired SEC Tools / Domain Inquiry."
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-2">Response Time</h3>
            <p className="text-slate-600 text-sm">
              We typically respond within 1-2 business days. For urgent matters, please indicate that in your message.
            </p>
          </div>
        </div>
      </Section>
    </>
  )
}
